import React, { useMemo } from 'react'
import styled from 'styled-components'
import { InputType } from './InputType'

type SearchBarProps = {
    value: string
    onChange: (e: string) => void
    placeholder: string
}

export const SearchBar = ({ value, onChange, placeholder }: SearchBarProps): JSX.Element => {
    return useMemo(
        () => (
            <DivContainerInput>
                <i className={'far fa-search'} />
                <input placeholder={placeholder} value={value || ''} onChange={e => onChange(e.target.value)} />
            </DivContainerInput>
        ),
        [onChange, placeholder, value]
    )
}

const DivContainerInput = styled.div`
    display: flex;
    align-items: center;
    height: 24px;
    border: 1px solid ${({ theme }) => theme?.['gray-400'] || '#C8CCD4'};
    border-radius: 3px;
    background-color: ${({ theme }) => theme?.['gray-0'] || '#FFFFFF'};
    margin-bottom: 16px;

    > i {
        display: flex;
        width: 15px;
        height: 15px;
        font-size: 14px;
        margin: 8px;
        color: ${({ theme }) => theme?.['gray-500'] || '#BAC0CB'};
        align-items: center;
        justify-content: center;
    }

    > input {
        width: calc(100% - 46px);
        border: none;
        outline: none;
        margin: 0 10px 0px 0px;
        display: flex;
        flex-grow: 1;
        font-size: 14px;
        color: ${({ theme }) => theme?.['gray-800'] || '#364159'};
        background-color: ${({ theme }) => theme?.['gray-0'] || '#FFFFFF'};
    }
`
